import React from 'react';
import { sensorUnits } from 'commons/src/constants';
import { SensorTypes, ThresholdsResourceScope } from 'commons/src/models/commonEnums';
import { ThresholdRange } from 'commons/src/models/commonTypeScript';
import { CustomOptions, ThresholdOptions, ThresholdUpdatePayload } from 'commons/src/models/customThresholdModels';
import SensorThresholdMgmt from './SensorThresholdMgmt';
import styles from './ThresholdMgmt.module.scss';

type Props = {
    thresholdData: {
        [sensor: string]: {
            customOptions?: CustomOptions;
            ranges: ThresholdRange[];
            unit: keyof typeof sensorUnits;
            thresholdOptions: ThresholdOptions;
        };
    };
    thresholdScope: ThresholdsResourceScope;
    parentThresholdScope?: ThresholdsResourceScope;
    buttonText: string;
    id: string | undefined;
    updateSuccessAction?: (id: string, payload: ThresholdUpdatePayload) => void;
    parentUrl?: string;
};
const ThresholdMgmt = ({
    thresholdData,
    thresholdScope,
    parentThresholdScope,
    buttonText,
    id,
    updateSuccessAction,
    parentUrl,
}: Props): React.ReactElement => {
    return (
        <div className={styles.list}>
            {Object.keys(thresholdData).map(sensorType => (
                <SensorThresholdMgmt
                    id={id}
                    key={sensorType}
                    sensorType={sensorType as SensorTypes}
                    thresholds={thresholdData[sensorType]}
                    buttonText={buttonText}
                    thresholdScope={thresholdScope}
                    parentThresholdScope={parentThresholdScope}
                    updateSuccessAction={updateSuccessAction}
                    parentUrl={parentUrl}
                />
            ))}
        </div>
    );
};

export default ThresholdMgmt;
